export const LibraryNavbar = {
  flow: 'x',
  align: 'center space-between',
  padding: 'Y2',
  top: '0',
  margin: '- -X2',
  border: '0',
  position: 'sticky',
  theme: 'common-box',
  zIndex: 2,
  gap: 'X',
  CanvasSearch: {
    round: 'radiusPill',
    fontSize: 'A1',
    flex: 1,
    Form: {
      Icon: {},
      Input: {
        paddingBlock: 'Z',
        placeholder: (el) => el.call('polyglot', 'editor.library.searchPlaceholder'),
        onInput: (ev, el, s) => {
          s.update({
            search: el.node.value
          })
        }
      }
    }
  },
  NavbarButtonSet: {
    gap: 'X2',
    margin: '- - - A2',
    padding: '0',
    Docs: {
      isActive: false,
      title: (el) => el.call('polyglot', 'editor.library.howItWorks'),
      icon: 'question mark',
      onClick: (ev, el) => {
        el.setWindow('docs', '/components')
      }
    }
  }
}
